<!-- Native select dropdown form field with label, chevron icon, and validation. -->

<script lang="ts">
import type { FormFieldController } from '@nzyme/vue-forms/components/defineFormField.js';
import { useSelectInput } from '@nzyme/vue-forms/components/useSelectInput.jsx';
import type { Slots } from '@nzyme/vue-utils/slots.js';
import { ChevronDown } from 'lucide-vue-next';

import FormFieldWrapper from './FormFieldWrapper.vue';

export const SelectInputProps = useSelectInput.props;
export const SelectInputEmits = useSelectInput.emits;
</script>

<script lang="ts" setup>
defineProps(SelectInputProps);
defineEmits(SelectInputEmits);

defineSlots<
  Slots<{
    default: { field: FormFieldController<string> };
    info: { field: FormFieldController<string> };
  }>
>();

const { SelectInput, field } = useSelectInput();
</script>

<template>
  <FormFieldWrapper
    :field="field"
    :label="label"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
  >
    <template #default="{ inputId }">
      <SelectInput
        :id="inputId"
        :class="css.select"
      >
        <slot :field="field" />
      </SelectInput>
      <ChevronDown :class="css.icon" />
    </template>

    <template #info>
      <slot
        name="info"
        :field="field"
      />
    </template>
  </FormFieldWrapper>
</template>

<style lang="scss" module="css">
.select {
  appearance: none;
  cursor: pointer;
  padding-right: $spacing-40 !important;

  &::-ms-expand {
    display: none;
  }
}

.icon {
  position: absolute;
  right: $spacing-12;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: $color-gray-600;
  pointer-events: none;
}
</style>
